import { ReactNode } from 'react';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';
import NsImage from '@britishgasenergy/react-nucleus/dist/nuc-components/NsImage';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsLandmark } from 'components/common/ns-landmark/NsLandmark';
import { NsTimeline } from 'components/common/ns-timeline/NsTimeline';
import { NsTimelineEvent } from 'components/common/ns-timeline/NsTimelineEvent';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useSelector, shallowEqual } from 'react-redux';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { useNavigation } from 'hooks/useNavigation';
import { useSupplyStatus } from 'hooks/useSupplyStatus';
import { useJaguar } from './hooks/useJaguar';

import jaguarStraightThumbUp from 'assets/images/jaguar-straight-thumb-up-1-1-crop.png';

export const testId = 'movingHomeOrderCompleteTestId';

type WrapperProps = {
  children: ReactNode;
};

const Wrapper = ({ children }: WrapperProps) => {
  return <>{children}</>;
};

export const MovingHomeOrderComplete = () => {
  const { isJaguar, isDesktop, columnRatio } = useJaguar();
  const { eventTypes, next } = useNavigation();

  const { isNepSplitSupply } = useSupplyStatus();
  const fuelType = useSelector(selectFuelType, shallowEqual);

  const isGas = fuelType.gas;

  const headingTitle = isNepSplitSupply ? (
    <>
      Thanks for staying with British Gas for your{' '}
      {isGas ? 'gas' : 'electricity'}
    </>
  ) : (
    <>Thanks for staying with British Gas</>
  );

  const handleGoNext = () => {
    next({ eventType: eventTypes.DIRECT_SALES });
  };

  const headingBody = isNepSplitSupply ? (
    <>
      <p>
        Now get a quote for your {isGas ? 'electricity' : 'gas'} and sign up
        online. It&apos;ll only take a minute. We&apos;ll contact your current
        supplier to arrange everything. It normally takes 3-5 days to switch
        suppliers.
      </p>
      <NsPrimaryCta onClick={handleGoNext}>
        Get a quote for your {isGas ? 'electricity' : 'gas'}
      </NsPrimaryCta>
    </>
  ) : (
    <p>We’ll get you moved into your new address.</p>
  );

  return (
    <>
      <NsLandmark type="hillside" decoration="cyan" heading={headingTitle}>
        {headingBody}
      </NsLandmark>
      <NsPanel testId={testId}>
        <NsColumn
          hockeypitch={
            columnRatio as '' | '1' | '2' | '3' | '1:2' | '2:1' | undefined
          }
        >
          {isJaguar && !isDesktop && <NsImage src={jaguarStraightThumbUp} />}
          <NsTimeline heading="What happens next" type="standard">
            <NsTimelineEvent
              wrapper={Wrapper}
              status="completed"
              heading="Check your inbox for our welcome Pack"
            >
              <p>
                We will send you a welcome email shortly which will confirm the
                details of your chosen tariff and cooling off period.
              </p>
            </NsTimelineEvent>
            <NsTimelineEvent
              wrapper={Wrapper}
              status="pending"
              heading="Move in progress"
            >
              <p>
                Your move should take around 24 hours. Look out for our emails -
                we will let you know if there is anything you need to do - like
                give us meter readings.
              </p>
            </NsTimelineEvent>
            <NsTimelineEvent
              wrapper={Wrapper}
              status="pending"
              heading="Moved in"
            >
              <p>
                Once you’re set up you should be able to manage most things
                through your online account or find answers to questions through
                our website. If you do need to get in touch - just webchat with
                one of our UK based team.
              </p>
            </NsTimelineEvent>
          </NsTimeline>
          {isJaguar && isDesktop && <NsImage src={jaguarStraightThumbUp} />}
        </NsColumn>
      </NsPanel>
    </>
  );
};
